export default __webpack_public_path__ + "static/media/dana_levy.c2b416de.jpeg";